var spacing = {"space-0":"0","space-025":"1px","space-05":"2px","space-1":"4px","space-2":"8px","space-3":"12px","space-4":"16px","space-5":"20px","space-6":"24px","space-8":"32px","space-10":"40px","space-12":"48px","space-16":"64px","space-20":"80px","space-24":"96px","space-28":"112px","space-32":"128px"};

export { spacing as default };
